export const modelConstants = {
    MODEL_GETALL: 'model/getall',
    MODEL_CLEAR: 'model/clear',
}